import { render } from "./Step3Confirmation.vue?vue&type=template&id=07cc4cfb&scoped=true"
import script from "./Step3Confirmation.vue?vue&type=script&lang=js"
export * from "./Step3Confirmation.vue?vue&type=script&lang=js"

import "./Step3Confirmation.vue?vue&type=style&index=0&id=07cc4cfb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07cc4cfb"]])

export default __exports__